import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const CharacterUnlockPopup = ({ characterId, onClose }) => {
  const { t } = useLanguage();

  return (
    <div className="fixed top-1/3 left-1/2 transform -translate-x-1/2 z-50">
      <div className="bg-gradient-to-r from-purple-500 to-pink-500 text-white p-6 rounded-2xl shadow-xl text-center max-w-xs w-full animate-flip">
        <div className="mb-3">
          <span className="text-4xl">🎉</span>
        </div>
        <h3 className="text-xl font-bold mb-2">{t('newCharacterUnlocked')}</h3>
        <p className="text-lg font-bold mb-1">{t(`characters.${characterId}.name`)}</p>
        <p className="text-sm mb-4">{t('tryCharacterPage')}</p>
        <button
          onClick={onClose}
          className="bg-white text-purple-500 px-5 py-2 rounded-xl font-bold transform hover:scale-105 transition-transform duration-200"
        >
          {t('awesome')}
        </button>
      </div>
    </div>
  );
};

export default CharacterUnlockPopup;